import {
  StyleSheet,
  Platform,
  View,
  useWindowDimensions,
} from "react-native";
import React from "react";
import { Text } from "../../../components/Themed";
import InputText from "../../../components/InputText";
import Colors from "../../../constants/Colors";
import GlobalContext from "../../../context/Global";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";

interface QuestionInfoProps {
  question: string;
  details: string;
  control: any;
  errors: any;
  team?: string;
  phone?: string;
}

const QuestionInfo: React.FC<QuestionInfoProps> = ({
  question,
  details,
  control,
  errors,
  team: propTeam,
  phone: propPhone,
}) => {
  const { isTablet: deviceIsTablet, user } = React.useContext(GlobalContext);
  const { width } = useWindowDimensions();
  const isTablet = deviceIsTablet || width >= 768;

  // Use props first, then fallback to user data
  const team = propTeam || user?.organization_info?.team;
  const phone = propPhone || user?.managed_phone_number;
  return (
    <View style={isTablet ? styles.page : styles.phonePage}>
      <View style={styles.container}>
        <Text size={26} lineHeight={28} style={styles.questionText}>
          {question}
        </Text>
        <Text size={20} lineHeight={28} style={styles.detailsText}>
          {details}
        </Text>
        <InputText
          control={control}
          label="First Name"
          name="first_name"
          errors={errors}
          required
        />
        <InputText
          control={control}
          label="Last Name"
          name="last_name"
          errors={errors}
          required
        />
        <InputText
          control={control}
          label="Email"
          name="email"
          errors={errors}
          required
        />
        <InputText
          control={control}
          label="Phone"
          name="phone"
          errors={errors}
          required
          type="phone-pad"
        />
        <Text style={styles.infoText}>
          {`By digitally signing, you give express consent to ${team} contacting you via SMS, email, calls, or prerecorded messages, including automated systems. Consent applies to all provided contact info and isn't required to register. You can opt out of SMS marketing when submitting this form. Message/data rates may apply. Text STOP to cancel or call `}
          <Text style={styles.phoneNumber}>
            {formatPhoneNumber(phone || "")}
          </Text>
          {` for help.`}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
  },
  phonePage: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: 500,
  },
  questionText: {
    marginBottom: 20,
    textAlign: "center",
    color: Colors.nuetral_grey_700,
  },
  detailsText: {
    textAlign: "center",
    color: Colors.nuetral_grey_700,
    marginBottom: 40,
  },
  infoText: {
    fontSize: 12,
    lineHeight: 20,
    color: Colors.nuetral_grey_600,
    marginTop: 20,
  },
  phoneNumber: {
    ...(Platform.OS === "web"
      ? {
          whiteSpace: "nowrap" as any,
          display: "inline-block" as any,
        }
      : { flexWrap: "nowrap" }),
    color: Colors.nuetral_grey_600,
  },
});

export default QuestionInfo;
